import { gql } from '@apollo/client';


export const SUBMIT_DATA = gql`
  mutation SaveCollegeChoice($collegeInput: CreateScoreRecipientInput!) {
    saveCollegeChoice(collegeInput: $collegeInput) {
      transactionId
      initiatedTransactionId
    }
  }
`;

export const PRODUCT_REMOVE = gql`
  mutation ProductRemove($productRemoveInput: ProductRemoveInput!) {
    productRemove(productRemoveInput: $productRemoveInput)
  }
`;

export const CONFIRM_REGISTRATION = gql` 
 mutation ConfirmRegistration($confirmRegistrationInput: ConfirmStatusInput!) {
  confirmRegistration(confirmRegistrationInput: $confirmRegistrationInput) {
    transactionId
  }
}
`;

export const VALIDATE_ADDRESS = gql`
  mutation ValidateAddress($input: AddressInput!) {
    validateAddress(input: $input) {
      status
      analysis
      enteredView
      suggestedView
      suggestedData
    }
  }
`;

export const UPDATE_CONTACT_INFORMATION = gql`
  mutation UpdateContactInformation($input: UpdateContactInfoInput!) {
    updateContactInformation(input: $input) {
      streetAddress1
      streetAddress2
      city
      state
      stateCode
      zipCode
      country
    }
  }
`;
